/**
 * The base class for an animation
 */
export default class CA_Animation {
  /**
   *
   * @param {object} config The configurations of the animation. Like duration: number, stopAfterIntersecting: boolean, observerConfig: object
   */
  constructor(animationType, config) {
    this.animationType = animationType;
    this.config = config;
  }
}
